(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-patch-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const patchOptions = document.querySelector('.custom-patch-options');
    if (!patchOptions) return;

    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const petNameInput = patchOptions.querySelector('[data-patch-option="pet-name"]');
    const petNameError = patchOptions.querySelector('[data-patch-error="pet-name"]');
    const fontSelect = patchOptions.querySelector('[data-patch-option="font"]');
    const colorInput = patchOptions.querySelector('[data-patch-option="color-input"]');
    const colorsContainer = patchOptions.querySelector('[data-patch-colors]');
    const variantSelect = document.querySelector('[name="id"]');
    const hiddenFields = {};
    let petNameTimeout = null;

    updatePatchOptionsForVariant(variantSelect?.value);

    document.addEventListener('change', (e) => {
        updatePatchOptionsForVariant(e.target?.getAttribute('data-variant-id'));
    });

    petNameInput?.addEventListener('input', (e) => {
        if (petNameTimeout) {
            clearTimeout(petNameTimeout);
        }

        petNameTimeout = setTimeout(() => {
            handleInputChange();
        }, 500);
    });

    fontSelect?.addEventListener('change', handleInputChange);

    colorsContainer?.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-patch-option="color"]');
        if (!btn) return;

        const currentVariantId = variantSelect?.value;
        if (btn.dataset.variantId !== currentVariantId) return;

        patchOptions.querySelectorAll('[data-patch-option="color"].selected').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        colorInput.value = btn.dataset.colorLabel || '';
        handleInputChange();
    });

    function handleInputChange() {
        validatePatchForm();
        dispatchPatchChangeEvent();
        syncInputToMainForm();
    }

    function syncInputToMainForm() {
        if (!mainForm) return;
        if (!isVisible()) {
            Object.values(hiddenFields).forEach(input => {
                if (input && input.parentNode) {
                    input.parentNode.removeChild(input);
                }
            });
            Object.keys(hiddenFields).forEach(key => delete hiddenFields[key]);
            return;
        }

        const data = {
            'Pet Name': petNameInput.value.trim(),
            'Font': fontSelect.value,
            'Color': patchOptions.querySelector('[data-patch-option="color"].selected')?.dataset.colorLabel || '',
        };

        Object.entries(data).forEach(([key, value]) => {
            let input = hiddenFields[key];

            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = `properties[${key}]`;
                hiddenFields[key] = input;
                mainForm.appendChild(input);
            }
            input.value = value;
        });
    }

    function updatePatchOptionsForVariant(variantId) {
        if (!variantId) return;

        if (petNameTimeout) {
            clearTimeout(petNameTimeout);
            petNameTimeout = null;
        }

        const hasPatchOptions = patchOptions.querySelector(`option[data-variant-id="${variantId}"]`) || 
                               patchOptions.querySelector(`[data-patch-option="color"][data-variant-id="${variantId}"]`);

        if (hasPatchOptions) {
            patchOptions.style.display = 'block';
            showOptionsForVariant(variantId);
        } else {
            patchOptions.style.display = 'none';
            resetPatchForm();
        }

        validatePatchForm();
        dispatchPatchChangeEvent();
    }

    function showOptionsForVariant(variantId) {
        patchOptions.querySelectorAll('option[data-variant-id]').forEach(option => {
            option.style.display = 'none';
        });
        patchOptions.querySelectorAll('[data-patch-option="color"][data-variant-id]').forEach(button => {
            button.style.display = 'none';
        });

        patchOptions.querySelectorAll(`option[data-variant-id="${variantId}"]`).forEach(option => {
            option.style.display = 'block';
        });
        patchOptions.querySelectorAll(`[data-patch-option="color"][data-variant-id="${variantId}"]`).forEach(button => {
            button.style.display = 'flex';
        });

        fontSelect.value = '';
        patchOptions.querySelectorAll('[data-patch-option="color"].selected').forEach(btn => btn.classList.remove('selected'));
        colorInput.value = '';

        const firstFontOption = patchOptions.querySelector(`option[data-variant-id="${variantId}"]`);
        if (firstFontOption) {
            fontSelect.value = firstFontOption.value;
        }

        const firstColorButton = patchOptions.querySelector(`[data-patch-option="color"][data-variant-id="${variantId}"]`);
        if (firstColorButton) {
            firstColorButton.classList.add('selected');
            colorInput.value = firstColorButton.dataset.colorLabel || '';
        }
    }

    function resetPatchForm() {
        petNameInput.value = '';
        colorInput.value = '';

        if (petNameTimeout) {
            clearTimeout(petNameTimeout);
            petNameTimeout = null;
        }

        if (petNameError) {
            petNameError.style.display = 'none';
        }
        if (petNameInput) {
            petNameInput.classList.remove('error');
        }

        patchOptions.querySelectorAll('[data-patch-option="color"].selected').forEach(s => s.classList.remove('selected'));
        
        Object.values(hiddenFields).forEach(input => {
            if (input && input.parentNode) {
                input.parentNode.removeChild(input);
            }
        });
        Object.keys(hiddenFields).forEach(key => delete hiddenFields[key]);
    }

    function validatePatchForm() {
        if (isPetNameValid()) {
            petNameError.style.display = 'none';
            petNameInput.classList.remove('error');
        } else {
            petNameError.style.display = 'block';
            petNameInput.classList.add('error');
        }

        patchOptions.dispatchEvent(new CustomEvent('product-form:custom-validation', {
            bubbles: true,
            detail: {
                id: 'custom-patch-options',
                valid: isValid(),
            }
        }));
    }

    function dispatchPatchChangeEvent() {
        if (!isPetNameValid()) return;

        const data = {
            petName: petNameInput.value.trim(),
            font: fontSelect.value,
            color: patchOptions.querySelector('[data-patch-option="color"].selected')?.dataset.colorValue || '',
        };

        document.dispatchEvent(new CustomEvent('patchOptionsChanged', { detail: data }));
    }

    function isPetNameValid() {
        if (!isVisible()) return true;
        if (!petNameInput) return true;
        if (!petNameInput.pattern) return true;
        if (!petNameInput.value) return true;

        return petNameInput.value.trim() === '' || new RegExp(petNameInput.pattern).test(petNameInput.value.trim());
    }

    function isValid() {
        if (!isVisible()) return true;

        const hasName = petNameInput.value.trim() !== '';
        const hasFont = fontSelect.value !== '';
        const hasColor = !!patchOptions.querySelector('[data-patch-option="color"].selected');

        const petNameValid = petNameInput.value.trim() === '' || new RegExp(petNameInput.pattern).test(petNameInput.value.trim());

        return hasName && hasFont && hasColor && petNameValid;
    }

    function isVisible() {
        return patchOptions.style.display === 'block';
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fabric-selection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const fabricSelection = document.querySelector('[data-fabric-selection]');
    if (!fabricSelection) return;

    const fabricDropdowns = fabricSelection.querySelectorAll('[data-fabric-dropdown]');
    const textureButtons = fabricSelection.querySelectorAll('[data-texture-btn]');

    function updatePropertyValue(fabricType, fabricName, textureName, glbHandle) {
        if (!fabricSelection) return;
        const form = fabricSelection.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        const propertyName = fabricType === 'top' ? 'Top Fabric' : 'Bottom Fabric';
        let propertyInput = form.querySelector(`input[name="properties[${propertyName}]"]`);

        if (!propertyInput) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${propertyName}]`;
            form.appendChild(input);
            propertyInput = input;
        }

        const inputEl = propertyInput;
        if (textureName) {
            inputEl.value = `${fabricName} - ${textureName}`;
        } else if (fabricName) {
            inputEl.value = fabricName;
        } else {
            inputEl.value = '';
        }

        validateForm();
    }

    function dispatchTextureSelectedEvent(fabricType, fabricName, textureName, glbHandle, textureSource, texturePreviewSource) {
        if (!fabricSelection) return;

        if (textureSource) {
            textureSource = textureSource.split('?')[0];
        }

        const event = new CustomEvent('fabricTextureSelected', {
            detail: {
                side: fabricType,
                fabricName: fabricName,
                glbHandle: glbHandle,
                textureName: textureName,
                textureSource: textureSource,
                texturePreviewSource: texturePreviewSource
            },
            bubbles: true,
            cancelable: true
        });

        fabricSelection.dispatchEvent(event);
    }

    function validateForm() {
        if (!fabricSelection) return;
        const topDropdown = fabricSelection.querySelector('[data-fabric-dropdown="top"]');
        const bottomDropdown = fabricSelection.querySelector('[data-fabric-dropdown="bottom"]');
        const topSelectedFabric = topDropdown ? topDropdown.value : '';
        const bottomSelectedFabric = bottomDropdown ? bottomDropdown.value : '';

        const topSelected = fabricSelection.querySelector(`[data-fabric-type="top"][data-selected="true"][data-fabric-name="${topSelectedFabric}"]`);
        const bottomSelected = fabricSelection.querySelector(`[data-fabric-type="bottom"][data-selected="true"][data-fabric-name="${bottomSelectedFabric}"]`);

        const styles = getComputedStyle(fabricSelection);
        const isVisible = styles.display !== 'none' && styles.visibility !== 'hidden';
        const isValid = isVisible && !!(topSelected && bottomSelected && topSelectedFabric && bottomSelectedFabric);

        const validationEvent = new CustomEvent('product-form:custom-validation', {
            bubbles: true,
            detail: {
                id: 'fabric-selection',
                valid: isValid,
            }
        });

        fabricSelection.dispatchEvent(validationEvent);
    }

    function showTextureSection(fabricType, fabricName) {
        if (!fabricSelection) return;
        const textureSection = fabricSelection.querySelector(`[data-texture-section="${fabricType}"]`);

        if (textureSection) {
            textureSection.style.display = 'block';

            const allFabricTextures = textureSection.querySelectorAll('[data-fabric-name]');
            allFabricTextures.forEach(group => {
                (group instanceof HTMLElement) && group.classList.remove('show');
            });

            const selectedTextures = textureSection.querySelectorAll('[data-texture-btn][data-selected="true"]');
            selectedTextures.forEach(btn => {
                (btn instanceof HTMLElement) && btn.removeAttribute('data-selected');
            });

            const fabricTextures = textureSection.querySelector(`[data-fabric-name="${fabricName}"]`);
            if (fabricTextures) {
                (fabricTextures instanceof HTMLElement) && fabricTextures.classList.add('show');
            }

            updatePropertyValue(fabricType, fabricName, '', '');
            validateForm();
        }
    }

    function hideTextureSection(fabricType) {
        if (!fabricSelection) return;
        const textureSection = fabricSelection.querySelector(`[data-texture-section="${fabricType}"]`);

        if (textureSection) {
            textureSection.style.display = 'none';

            const fabricTextures = textureSection.querySelectorAll('[data-fabric-name]');
            fabricTextures.forEach(group => {
                (group instanceof HTMLElement) && group.classList.remove('show');
            });

            const selectedTextures = textureSection.querySelectorAll('[data-texture-btn][data-selected="true"]');
            selectedTextures.forEach(btn => {
                (btn instanceof HTMLElement) && btn.removeAttribute('data-selected');
            });
        }
    }

    function handleDropdownChange(dropdown) {
        if (!fabricSelection) return;
        const fabricType = dropdown.getAttribute('data-fabric-dropdown') || '';
        const selectedFabric = dropdown.value;
        const autoShow = fabricSelection.dataset.autoShow === 'true';

        if (selectedFabric) {
            showTextureSection(fabricType, selectedFabric);
            updatePropertyValue(fabricType, selectedFabric, '', '');

            if (autoShow) {
                const textureSection = fabricSelection.querySelector(`[data-texture-section="${fabricType}"]`);
                if (textureSection) {
                    textureSection.style.display = 'block';
                }
            }
        } else {
            hideTextureSection(fabricType);
            updatePropertyValue(fabricType, '', '', '');
        }
    }

    function handleTextureSelection(button) {
        if (!fabricSelection) return;
        const fabricType = button.getAttribute('data-fabric-type') || '';
        const fabricName = button.getAttribute('data-fabric-name') || '';
        const textureName = button.getAttribute('data-texture-name') || '';
        const glbHandle = button.getAttribute('data-glb-handle') || '';
        const textureSource = button.getAttribute('data-texture-image') || '';
        const texturePreviewSource = button.getAttribute('data-texture-preview-image') || '';

        fabricSelection.querySelectorAll(`[data-fabric-type="${fabricType}"][data-selected="true"]`).forEach(btn => {
            btn.removeAttribute('data-selected');
        });

        button.setAttribute('data-selected', 'true');

        updatePropertyValue(fabricType, fabricName, textureName, glbHandle);

        dispatchTextureSelectedEvent(fabricType, fabricName, textureName, glbHandle, textureSource, texturePreviewSource);
    }

    fabricDropdowns.forEach(dropdown => {
        dropdown.addEventListener('change', function () {
            handleDropdownChange(this);
        });
    });

    textureButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleTextureSelection(this);
        });

        button.addEventListener('mouseenter', function () {
            const showPreview = fabricSelection.dataset.showPreview === 'true';
            if (showPreview) {
                const textureImage = this.getAttribute('data-texture-image');
                this.style.setProperty('--hover-preview-image', `url(${textureImage})`);
            }
        });
    });

    validateForm();

    const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
    variantSelectors.forEach(selector => {
        selector.addEventListener('change', function () {
            setTimeout(() => {
                validateForm();
            }, 100);
        });
    });

    const form = fabricSelection ? (fabricSelection.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]')) : null;
    if (form) {
        form.addEventListener('change', function (e) {
            const target = e.target;
            if (!target || target.closest('[data-fabric-selection]')) return;
            validateForm();
        });
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' &&
                (mutation.attributeName === 'data-variant-id' ||
                    mutation.attributeName === 'data-selected-variant-id' ||
                    mutation.attributeName === 'value')) {
                setTimeout(() => {
                    validateForm();
                }, 100);
            }
        });
    });

    if (form) {
        observer.observe(form, {
            attributes: true,
            subtree: true,
            attributeFilter: ['data-variant-id', 'data-selected-variant-id', 'value']
        });
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-information"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.product-information-toggle');
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const content = document.getElementById(this.getAttribute('aria-controls'));
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const expandText = this.getAttribute('data-expand-text');
        const collapseText = this.getAttribute('data-collapse-text');
        
        this.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
        
        this.setAttribute('aria-label', isExpanded ? expandText : collapseText);
        
        if (isExpanded) {
          content.style.maxHeight = '0';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
